export default __webpack_public_path__ + "static/media/shoppingCart-trash-bin.f28c9df6.svg";